import Model from "./Model";

export default class ModuleTypology extends Model {
  name!: string;
  static type = "moduleTypologies";
  get type() {
    return ModuleTypology.type;
  }
  static humanName(name: string) {
    if (name) {
      const letters = name.split("");
      letters[0] = letters[0].toLocaleUpperCase();
      return letters.join("");
    }
    return name;
  }
}
